<template>
  <div class="dashboard">
    <div class="welcome-section">
      <h1>欢迎使用商户管理后台</h1>
      <p>{{ currentUser ? `欢迎您，${currentUser.username}！` : '欢迎您！' }}</p>
    </div>

    <div class="stats-grid">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon technician">
              <i class="el-icon-user"></i>
            </div>
            <div class="stat-content">
              <h3>技师管理</h3>
              <p>管理技师信息和状态</p>
              <el-button type="primary" size="small" @click="$router.push('/technician')">
                进入管理
              </el-button>
            </div>
          </div>
        </el-col>
        
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon orders">
              <i class="el-icon-document"></i>
            </div>
            <div class="stat-content">
              <h3>订单管理</h3>
              <p>查看和处理订单信息</p>
              <el-button type="primary" size="small" @click="$router.push('/orders')">
                进入管理
              </el-button>
            </div>
          </div>
        </el-col>
        
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon finance">
              <i class="el-icon-money"></i>
            </div>
            <div class="stat-content">
              <h3>财务管理</h3>
              <p>财务数据和报表</p>
              <el-button type="primary" size="small" @click="$router.push('/finance')">
                进入管理
              </el-button>
            </div>
          </div>
        </el-col>
        
      </el-row>
    </div>

    <div class="quick-actions">
      <h2>快速操作</h2>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="action-card">
            <div slot="header">
              <span>系统概览</span>
            </div>
            <div class="overview-content">
              <p><i class="el-icon-time"></i> 系统运行正常</p>
              <p><i class="el-icon-check"></i> 所有服务在线</p>
              <p><i class="el-icon-info"></i> 最后更新: {{ getCurrentTime() }}</p>
            </div>
          </el-card>
        </el-col>
        
        <el-col :span="12">
          <el-card class="action-card">
            <div slot="header">
              <span>常用功能</span>
            </div>
            <div class="actions-content">
              <el-button type="text" @click="$router.push('/technician')">
                <i class="el-icon-user"></i> 查看技师
              </el-button>
              <el-button type="text" @click="$router.push('/orders')">
                <i class="el-icon-document"></i> 处理订单
              </el-button>
              <el-button type="text" @click="$router.push('/finance')">
                <i class="el-icon-money"></i> 财务管理
              </el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    getCurrentTime() {
      return new Date().toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 0;
}

.welcome-section {
  background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
  color: white;
  padding: 40px;
  border-radius: 8px;
  margin-bottom: 30px;
  text-align: center;
}

.welcome-section h1 {
  font-size: 28px;
  margin-bottom: 10px;
  font-weight: 300;
}

.welcome-section p {
  font-size: 16px;
  opacity: 0.9;
}

.stats-grid {
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 24px;
  color: white;
}

.stat-icon.technician {
  background: #67C23A;
}

.stat-icon.orders {
  background: #E6A23C;
}

.stat-icon.finance {
  background: #F56C6C;
}

.stat-icon.users {
  background: #909399;
}

.stat-content h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}

.stat-content p {
  color: #666;
  margin-bottom: 15px;
  font-size: 14px;
}

.quick-actions h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
}

.action-card {
  margin-bottom: 20px;
}

.overview-content p {
  margin-bottom: 10px;
  color: #666;
}

.overview-content i {
  color: #409EFF;
  margin-right: 8px;
}

.actions-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.actions-content .el-button {
  text-align: left;
  justify-content: flex-start;
  padding: 10px 0;
}

.actions-content .el-button i {
  margin-right: 8px;
}
</style>
